import { NgModule } from '@angular/core';
import { HeaderModule } from './header/header.module';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
// import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { createTranslateLoader } from './app.module';
// import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PersianNumberPipe } from 'src/services/persian-number.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        HeaderModule,
        TranslateModule.forChild(),
    ],
    declarations: [PersianNumberPipe,],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        HeaderModule,
        TranslateModule,
        PersianNumberPipe,
    ],
    providers: []
})
export class ShareModule { }
